import React from 'react';

const relativeTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  const delta = Date.now() - date.getTime();
  const minutes = Math.round(delta / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString();
};

const ChatSidebar = ({
  conversations,
  activeId,
  onNew,
  onSelect,
  onRename,
  onDelete,
}) => (
  <aside className="chat-sidebar">
    <button type="button" className="chat-new-button" onClick={onNew}>
      <i className="bi bi-plus-lg" />
      New chat
    </button>
    <div className="chat-sidebar-label">Chats</div>
    <div className="chat-sidebar-list">
      {conversations.length === 0 && (
        <p className="chat-sidebar-empty">No saved chats yet.</p>
      )}
      {conversations.map((conversation) => (
        <div
          key={conversation.id}
          className={`chat-sidebar-item${String(conversation.id) === String(activeId) ? ' is-active' : ''}`}
        >
          <button
            type="button"
            className="chat-sidebar-item-main"
            onClick={() => onSelect(conversation.id)}
          >
            <span className="chat-sidebar-title">{conversation.title || 'New chat'}</span>
            <span className="chat-sidebar-time">{relativeTime(conversation.updatedAt)}</span>
          </button>
          <div className="chat-sidebar-actions">
            <button
              type="button"
              aria-label="Rename chat"
              onClick={() => {
                const next = window.prompt('Rename chat', conversation.title || '');
                if (next && next.trim()) onRename(conversation.id, next.trim());
              }}
            >
              <i className="bi bi-pencil" />
            </button>
            <button
              type="button"
              aria-label="Delete chat"
              onClick={() => {
                if (window.confirm('Delete this chat?')) onDelete(conversation.id);
              }}
            >
              <i className="bi bi-trash" />
            </button>
          </div>
        </div>
      ))}
    </div>
  </aside>
);

export default ChatSidebar;
export { relativeTime };
